// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ContainerTwoToneSvg from "@ant-design/icons-svg/es/asn/ContainerTwoTone";
import AntdIcon from '../components/AntdIcon';

var ContainerTwoTone = function ContainerTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ContainerTwoToneSvg
  }));
};

ContainerTwoTone.displayName = 'ContainerTwoTone';
export default React.forwardRef(ContainerTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ContainerTwoTone.js
// module id = 861
// module chunks = 0